import React from 'react';

interface HilChatTextInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled?: boolean;
  /** Appended to the fixed base classes — lets a host toggle a modifier (e.g. an expanded/maximized height) without this component owning that state itself. */
  className?: string;
}

/** Purely controlled — owns no state, no submit logic. Enter sends, Shift+Enter inserts a newline. */
export function HilChatTextInput({ value, onChange, onSubmit, disabled, className }: HilChatTextInputProps): React.JSX.Element {
  return (
    <textarea
      className={['hil-chat-composer__input', 'hil-textarea', className].filter(Boolean).join(' ')}
      value={value}
      onChange={e => onChange(e.target.value)}
      onKeyDown={e => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          onSubmit();
        }
      }}
      placeholder="Type your reply…"
      disabled={disabled}
    />
  );
}
